import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';
import UnsavedChangeIcon from './UnsavedChangeIcon';

const UnsavedChangesWarning = () => {
  const { t } = useTranslation('SaveChangesMessage');

  return (
    <Alert severity="warning" icon={<UnsavedChangeIcon />} variant="outlined">
      {t('For changes to take effect you must save')}
    </Alert>
  );
};

export default UnsavedChangesWarning;
